import { useMutation } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";

// Backs /admin/item-cache/clear?catMgrCode=X&banner=Y — invalidates the
// per-(cat-mgr × banner) item lookup cache that the legacy ManageItemCache.aspx
// purged via CacheManager. The v1 API replaces the in-process .NET cache with
// a complete refresh of the RP_ITEM_AUTH_BANNERS_MV materialized view; the
// cat-mgr / banner params are recorded for audit/logging only.

const baseUrl = "/dm/V1/admin/item-cache";

export interface ClearItemCacheRequest {
  catMgrCode: number;
  banner: string;
}

export interface ClearItemCacheResponse {
  catMgrCode: number;
  banner: string;
  refreshedAt: string;
  message: string;
}

export const useClearItemCache = () =>
  useMutation({
    mutationFn: async (
      req: ClearItemCacheRequest
    ): Promise<ClearItemCacheResponse> => {
      const response = await apiClient.post<ClearItemCacheResponse>(
        `${baseUrl}/clear`,
        null,
        { params: { catMgrCode: req.catMgrCode, banner: req.banner } }
      );
      return response.data;
    },
  });
